<template>
    <div class="row">
        <!--Title-->
        <div class="mb-3 text-right col-md-12">
                <h4 class="title center-title pull-left">Evaluaciones</h4>
        </div>
        <!--./Title-->
        <!-- <modal :show.sync="showBalance" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Balance</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)" @click="openBalance(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.studies.length > 1">
                <p-button @click="openConsolidatedBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-success">Balance consolidado</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="openBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy, index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.codebtor_study">
                <p-button @click="openBalance(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowBalanceMethod()" link>Cancelar</p-button>
            </template>
        </modal> -->
        <modal :show.sync="showBalance" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Balance</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)" @click="openBalance(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isFirstAgroConsolidated(actualAssessmentComputed) && isFirstAgro(actualAssessmentComputed, index)" @click="openBalance(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <!-- <a href='#' onclick="window.open('https://emi-test.namtrik.dev/export/pdf/worksheet/1/1','Balance','width=250,height=600,screenX=25,screenY=25,resizable=yes,scrollbars=yes '); return false"><p-button type="block btn-warning">Estudio {{study.id}}</p-button></a> -->
                <div v-if="isFirstAgroConsolidated(actualAssessmentComputed) && isFirstAgro(actualAssessmentComputed, index)">
                    <p-button @click="openCashFlow(actualAssessmentComputed.assessment,study.id)" type="block btn-success">Flujo de caja</p-button>
                </div>
            </div>
            <div v-if="actualAssessmentComputed != '' && (actualAssessmentComputed.studies.length > 1 || isCustomerPymeConsolidated(actualAssessmentComputed)) && !isFirstAgroConsolidated(actualAssessmentComputed)">
                <p-button @click="openConsolidatedBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-success">Balance consolidado</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="openBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy, index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.codebtor_study">
                <p-button @click="openBalance(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="openCashFlow(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-success">Flujo de caja</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowBalanceMethod()" link>Cancelar</p-button>
            </template>
        </modal>

        <!-- <modal :show.sync="showBalanceEmail" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar balance</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button @click="sendBalance(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.studies.length > 1">
                <p-button @click="sendConsolidatedBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-success">Balance consolidado</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="sendBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button @click="sendBalance(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowBalanceEmailMethod()" link>Cancelar</p-button>
            </template>
        </modal> -->
        <modal :show.sync="showBalanceEmail" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar balance</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)" @click="sendBalance(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isFirstAgroConsolidated(actualAssessmentComputed) && isFirstAgro(actualAssessmentComputed, index)" @click="sendBalance(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <!-- <a href='#' onclick="window.open('https://emi-test.namtrik.dev/export/pdf/worksheet/1/1','Balance','width=250,height=600,screenX=25,screenY=25,resizable=yes,scrollbars=yes '); return false"><p-button type="block btn-warning">Estudio {{study.id}}</p-button></a> -->
                <div v-if="isFirstAgroConsolidated(actualAssessmentComputed) && isFirstAgro(actualAssessmentComputed, index)">
                    <p-button @click="sendCashFlow(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-success">Flujo de caja</p-button>
                </div>
            </div>
            <!-- <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.studies.length > 1"> -->
            <div v-if="actualAssessmentComputed != '' && (actualAssessmentComputed.studies.length > 1 || isCustomerPymeConsolidated(actualAssessmentComputed)) && !isFirstAgroConsolidated(actualAssessmentComputed)">
                <p-button @click="sendConsolidatedBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-success">Balance consolidado</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="sendBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button @click="sendBalance(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="sendBalance(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-success">Flujo de caja</p-button>
            </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowBalanceEmailMethod()" link>Cancelar</p-button>
            </template>
        </modal>

        <!-- <modal :show.sync="showBalanceFtp" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar balance</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button @click="sendFtpBalance(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.studies.length > 1">
                <p-button @click="sendFtpConsolidatedBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-success">Balance consolidado</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="sendFtpBalance(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button @click="sendFtpBalance(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowBalanceFtpMethod()" link>Cancelar</p-button>
            </template>
        </modal> -->
        <!-- <modal :show.sync="showWorksheet" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Hoja de trabajo</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button @click="openWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="openWorksheet(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button @click="openWorksheet(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowWorksheetMethod()" link>Cancelar</p-button>
            </template>
        </modal> -->
        <modal :show.sync="showWorksheet" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Hoja de trabajo</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)"  @click="openWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isFirstAgro(actualAssessmentComputed,index)"  @click="openAgroWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isSecondAgro(actualAssessmentComputed,index)"  @click="openAgroMicroWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <!-- <a href='#' onclick="window.open('https://emi-test.namtrik.dev/export/pdf/worksheet/1/1','Balance','width=250,height=600,screenX=25,screenY=25,resizable=yes,scrollbars=yes '); return false"><p-button type="block btn-warning">Estudio {{study.id}}</p-button></a> -->
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="openWorksheet(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button v-if="!isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="openWorksheet(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="openWorksheet(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowWorksheetMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <!-- <modal :show.sync="showWorksheetEmail" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar hoja de trabajo</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button @click="sendWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="sendWorksheet(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button @click="sendWorksheet(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowWorksheetEmailMethod()" link>Cancelar</p-button>
            </template>
        </modal> -->
        <modal :show.sync="showWorksheetEmail" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar hoja de trabajo</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)" @click="sendWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isFirstAgro(actualAssessmentComputed,index)" @click="sendWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isSecondAgro(actualAssessmentComputed,index)" @click="sendAgroMicroWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <!-- <a href='#' onclick="window.open('https://emi-test.namtrik.dev/export/pdf/worksheet/1/1','Balance','width=250,height=600,screenX=25,screenY=25,resizable=yes,scrollbars=yes '); return false"><p-button type="block btn-warning">Estudio {{study.id}}</p-button></a> -->
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="sendWorksheet(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button v-if="!isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="sendWorksheet(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="sendWorksheet(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowWorksheetEmailMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <!-- <modal :show.sync="showWorksheetFtp" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar hoja de trabajo</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button @click="sendFtpWorksheet(actualAssessmentComputed.assessment,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="sendFtpWorksheet(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button @click="sendFtpWorksheet(actualAssessmentComputed.assessment,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowWorksheetFtpMethod()" link>Cancelar</p-button>
            </template>
        </modal> -->
        <modal :show.sync="showCharacterAnalysis" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Análisis de caracter</h4>
            <h6 class="title title-up">Cliente</h6>
            <div>
                <p-button @click="openCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-warning">Analisis de caracter</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <div>
                    <p-button @click="openCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div>
                    <p-button @click="openCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.codebtors[0].codebtor_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowCharacterAnalysisMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showCharacterAnalysisEmail" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar análisis de caracter</h4>
            <h6 class="title title-up">Cliente</h6>
            <div>
                <p-button @click="sendCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-warning">Analisis de caracter</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <div>
                    <p-button @click="sendCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div>
                    <p-button @click="sendCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.codebtors[0].codebtor_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowCharacterAnalysisEmailMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showCharacterAnalysisFtp" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar análisis de caracter</h4>
            <h6 class="title title-up">Cliente</h6>
            <div>
                <p-button @click="sendFtpCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.person)" type="block btn-warning">Analisis de caracter</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <div>
                    <p-button @click="sendFtpCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.spouse_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div>
                    <p-button @click="sendFtpCharacterAnalysis(actualAssessmentComputed.assessment,actualAssessmentComputed.codebtors[0].codebtor_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowCharacterAnalysisFtpMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showFM100" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">FM100</h4>
            <h6 class="title title-up">Cliente</h6>
            <div>
                <p-button @click="openFM100(actualAssessmentComputed.fm100IdCustomer)" type="block btn-warning">FM100 Cliente</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0 && actualAssessmentComputed.codebtors[0].fm100IdCodebtor != null">
                <h6 class="title title-up">Codeudor</h6>
                <div>
                <p-button @click="openFM100(actualAssessmentComputed.codebtors[0].fm100IdCodebtor)" type="block btn-warning">FM100</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowFM100Method()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showFM102" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">FM102</h4>
            <h6 class="title title-up">Formulario FM102</h6>
            <div>
                <p-button @click="openFM102(actualAssessmentComputed.fm102Id)" type="block btn-warning">FM102 Evaluación</p-button>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowFM102Method()" link>Cancelar</p-button>
            </template>
        </modal>
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.financialAssessments.loading"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <!-- <loading :active.sync="isSending"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading> -->
        <!--./Sending state-->
        <!--Empty state-->
        <!--<div v-if="tableData && !tableData.length && !this.$apollo.queries.financialAssessments.loading" class="mt-3 col-md-12 card">
            <div class="card-header">
            </div>
            <div class="card-body">
                <img class="no_data_center"  v-bind:src="no_data_image" alt="">
            </div>
        </div>-->
        <!--./Empty state-->
        <!--Filter data-->
        <div class="col-md-12 card">
            <form>
            <div class="card-header">
                <div class="category">Selecciona las fechas</div>
            </div>
            <div class="card-body row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Fecha inicial</label>
                        <el-date-picker
                            v-model="model.startdate"
                            type="datetime"
                            placeholder="Seleccione fecha inicial">
                        </el-date-picker>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Fecha final</label>
                        <el-date-picker
                            v-model="model.enddate"
                            type="datetime"
                            placeholder="Seleccione fecha final">
                        </el-date-picker>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Regional</label>
                        <fg-input   type="text"
                                    name="user"
                                    autocomplete="off"
                                    :error="getError('user')">
                                <el-select class="select-warning"
                                        @change="resetOffice()"
                                        size="large"
                                        placeholder="Seleccione regional..."
                                        v-model="model.regional">
                                <el-option class="select-warning"
                                value=""
                                label="Seleccione">
                                </el-option>
                                <el-option v-for="option in regionals_array"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Agencia</label>
                        <fg-input
                                    type="text"
                                    name="user"
                                    autocomplete="off"
                                    :error="getError('user')">
                                <el-select class="select-warning"
                                        size="large"
                                        placeholder="Seleccione agencia..."
                                        v-model="model.office">
                                <el-option v-for="option in offices_array_computed"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>
                <!-- <div class="col-md-6">
                    <div class="form-group">
                        <label>Usuario</label>
                        <fg-input
                                    type="text"
                                    name="user"
                                    autocomplete="off"
                                    :error="getError('user')">
                                <el-select class="select-warning"
                                        size="large"
                                        placeholder="Seleccione usuario..."
                                        v-model="model.user">
                                <el-option class="select-warning"
                                value=""
                                label="Todos">
                                </el-option>
                                <el-option v-for="option in users_array"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name+' '+option.surname"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div> -->
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Estado</label>
                        <fg-input
                                    type="text"
                                    name="estado"
                                    autocomplete="off"
                                    :error="getError('estado')">
                                <el-select class="select-warning"
                                        size="large"
                                        placeholder="Seleccione estado..."
                                        v-model="model.status">
                                <el-option class="select-warning"
                                value=""
                                label="Todos">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="InProcess"
                                        label="En trámite">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Finished"
                                        label="Finalizada">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click.prevent="validate" type="success">Aceptar</p-button>
                    <p-button @click="cancelForm()" type="default" class="pull-left">Cancelar</p-button>
                </div>
            </div>
            </form>
        </div>
        <!--/Filter data-->
        <!--Regionals data-->
        <div v-if="tableData &&  tableData.length && !this.$apollo.queries.financialAssessments.loading" class="col-md-12 card">
        <div :id="'toAssessmentElement'"  class="card-header">
            <div class="category">Lista de evaluaciones</div>
        </div>
        <div class="card-body row">
            <div class="col-sm-4">
                <div>
                    <fg-input class="input-sm"
                            placeholder="Buscar"
                            v-model="searchQuery"
                            addon-right-icon="nc-icon nc-zoom-split">
                    </fg-input>
                </div>
            </div>
            <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                        :data="queriedData"
                        border
                        style="width: 100%">
                <el-table-column v-for="column in tableColumns"
                                :key="column.label"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :fixed="column.fixed"
                                :label="column.label">
                </el-table-column>
                <el-table-column
                :min-width="200"
                class-name="td-actions"
                label="Balance">
                <template slot-scope="props">
                    <el-tooltip content="Balance" placement="left">
                        <p-button @click="showBalanceMethod(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip content="Enviar a correo" placement="left">
                        <p-button @click="showBalanceEmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                    <!-- <el-tooltip content="Enviar a FTP" placement="left">
                        <p-button @click="showBalanceFtpMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip> -->
                </template>
                </el-table-column>
                <el-table-column
                :min-width="200"
                class-name="td-actions"
                label="H.T">
                <template slot-scope="props">
                    <el-tooltip content="Hoja de trabajo" placement="left">
                        <p-button @click="showWorksheetMethod(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip content="Enviar a correo" placement="left">
                        <p-button @click="showWorksheetEmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                    <!-- <el-tooltip content="Enviar a FTP" placement="left">
                        <p-button @click="showWorksheetFtpMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip> -->
                </template>
                </el-table-column>
                <el-table-column
                :min-width="200"
                class-name="td-actions"
                label="E.C">
                <template slot-scope="props">
                    <el-tooltip content="Evaluación de Caracter" placement="left">
                        <p-button @click="showCharacterAnalysisMethod(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip content="Enviar a correo" placement="left">
                        <p-button @click="showCharacterAnalysisEmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                    <!-- <el-tooltip content="Enviar a FTP" placement="left">
                        <p-button @click="showCharacterAnalysisFtpMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip> -->
                </template>
                </el-table-column>
                <el-table-column
                :min-width="200"
                class-name="td-actions"
                label="FM">
                <template slot-scope="props">
                    <el-tooltip v-if="props.row.fm100IdCustomer != null" content="FM100" placement="left">
                        <p-button @click="showFM100Method(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip v-if="props.row.fm102Id != null" content="FM102" placement="left">
                        <p-button @click="showFM102Method(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
                <el-table-column
                :min-width="120"
                class-name="td-actions"
                label="Log">
                <template slot-scope="props">
                    <el-tooltip content="Log de trazabilidad" placement="left">
                        <p-button type="primary" :disabled="logDeactivate(props)" size="sm" icon @click="showLog(props)">
                            <i class="fa fa-search"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
                <!--<el-table-column
                :min-width="120"
                class-name="td-actions"
                label="Enviar">
                <template slot-scope="props">
                    <el-tooltip content="Enviar" placement="left">
                        <p-button @click="showEmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>-->
            </el-table>
            </div>
            <div class="col-sm-6 pagination-info">
            <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} registros</p>
            </div>
            <div class="col-sm-12 mt-2">
                <el-select
                    class="select-default pull-left"
                    v-model="pagination.perPage"
                    placeholder="Per page">
                    <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <p-pagination class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total">
                </p-pagination>
            </div>
        </div>
        </div>
        <!--./Regionals data-->
        <!--Add Regional form-->
        <div v-if="logAssessment != '' " class="col-md-12 card">
            <div :id="'toLogTableElement'" class="card-header">
                <h4 class="card-title">
                Registro de trazabilidad de la evaluación
                </h4>
            </div>
            <el-table class="table-striped"
                        :data="logAssessment"
                        border
                        style="width: 100%">
                <el-table-column v-for="column in logColumns"
                                :key="column.label"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :label="column.label">
                </el-table-column>
            </el-table>
            <div class="card-footer">
                <div class="text-right">
                    <p-button type="default" class="pull-left" @click="cancelLogForm">Cancelar</p-button>
                </div>
            </div>
        </div>
        <!--./Add Regional form-->
    </div>
</template>
    <script>
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import SecureLS from 'secure-ls';
    import VueScrollTo from 'vue-scrollto'
    import {Table, TableColumn, Select, Option, DatePicker, TimeSelect, Button} from 'element-ui'
    import { TimeLine, TimeLineItem, Modal, Badge } from 'src/components/UIComponents'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { regionals } from 'src/api/graphql/queries/setup/AllRegionals';
    import { offices } from 'src/api/graphql/queries/setup/AllOffices';
    import { users } from 'src/api/graphql/queries/user/AllUsers';
    import { activityTypes } from 'src/api/graphql/queries/setup/AllActivityTypes';
    import { productTypes } from 'src/api/graphql/queries/setup/AllProductTypes';
    import { financialAssessments } from 'src/api/graphql/queries/assessments/AllAssessments';
    import { CREATE_ACTIVITY_TYPE } from 'src/api/graphql/mutations/setup/AddEditActivityTypes';
    import { SHARE_GENERAL_BALANCE_EMAIL } from 'src/api/graphql/mutations/share/ShareConsolidatedBalanceEmail';
    import { SHARE_BALANCE_EMAIL } from 'src/api/graphql/mutations/share/ShareBalanceEmail';
    import { SHARE_WORKSHEET_EMAIL } from 'src/api/graphql/mutations/share/ShareWorksheetEmail';
    import { SHARE_ANALYSIS_EMAIL } from 'src/api/graphql/mutations/share/ShareAnalysisEmail';
    import { SHARE_GENERAL_BALANCE_FTP } from 'src/api/graphql/mutations/share/ShareConsolidatedBalanceFtp';
    import { SHARE_BALANCE_FTP } from 'src/api/graphql/mutations/share/ShareBalanceFtp';
    import { SHARE_WORKSHEET_FTP } from 'src/api/graphql/mutations/share/ShareWorksheetFtp';
    import { SHARE_ANALYSIS_FTP } from 'src/api/graphql/mutations/share/ShareAnalysisFtp';
    import { REFRESH_TOKEN } from 'src/api/graphql/mutations/auth/RefreshToken';
    import { VERIFY_TOKEN } from 'src/api/graphql/mutations/auth/VerifyToken';
    import { orderBy , sortBy , find } from 'lodash';
    import moment from 'moment'
    import axios from 'axios'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    // You can also pass in the default options
    Vue.use(VueScrollTo, {
            container: "body",
            duration: 500,
            easing: "ease",
            offset: 0,
            force: true,
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false,
            x: false,
            y: true
    })
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
        productTypes: {
                query: productTypes,
                skip: false,
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.productTypes.edges.length == 0)
                    {
                        this.productTypes_array = [];
                    }
                    else
                    {
                        this.setProductTypes(data.productTypes);
                        this.$apollo.queries.productTypes.skip = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
            },
        financialAssessments: {
                    query: financialAssessments,
                    variables() {
                        return {
                            status: this.status_fetch,
                            analyst: this.analyst_fetch,
                            office: this.office_fetch,
                            createdAt_Gt: this.startdate_fetch,
                            createdAt_Lt: this.enddate_fetch,
                        }
                    },
                    skip() {
                        return this.skipAssessments
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.financialAssessments.edges.length == 0)
                        {
                            this.showNotificationError('No hay evaluaciones registradas');
                        }
                        else
                        {
                            this.setFinancialAssessments(data.financialAssessments);
                        }

                    },
                    // Si encontró algún error.
                    error(error) {

                    },
                },
        // users:    {
        //             query: users,
        //             skip: false,
        //             fetchPolicy: 'network-only',
        //             // Si tenemos un resultado, pero no encontró el slug.
        //             result({ data, loading, networkStatus }) {
        //                 if(data.users.edges.length == 0)
        //                 {
        //                     this.users = [];
        //                 }
        //                 else
        //                 {
        //                     this.setUsers(data.users);
        //                     this.$apollo.queries.users.skip = true;
        //                 }

        //             },
        //             // Si encontró algún error.
        //             error(error) {

        //             },
        //         },
        offices:{
                    query: offices,
                    variables:{
                        isActive: true
                    },
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {

                        if(data.offices.edges.length == 0)
                        {
                            this.offices = [];
                        }
                        else
                        {
                            this.setOffices(data.offices);
                            this.$apollo.queries.offices.skip = true;
                        }

                    },
                    // Si encontró algún error.
                    error(error) {

                    },
                },
        regionals: {
                query: regionals,
                skip: false,
                variables: {
                    isActive: true
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.regionals.edges.length == 0)
                    {
                        this.regionals_array = [];
                    }
                    else
                    {
                        this.setRegionals(data.regionals);
                        this.$apollo.queries.regionals.skip = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
            },
        },
        components: {
        Modal,
        TimeLine,
        TimeLineItem,
        PPagination,
        Loading,
        Badge,
        [Tooltip.name]: Tooltip,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Button.name]: Button,
        },
        computed: {
        actualAssessmentComputed () {
            if (this.actualAssessment != null) {
                return this.actualAssessment;
            }
            else {
                var array = [];
                return array;
            }
        },
        offices_array_computed(){
            return this.offices_array.filter(i => i.regional == this.model.regional)
        },
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
        * Searches through table data and returns a paginated array.
        * Note that this should not be used for table with a lot of data as it might be slow!
        * Do the search and the pagination on the server and display the data retrieved from server instead.
        * @returns {computed.pagedData}
        */
        queriedData () {
            if (!this.searchQuery) {
            this.pagination.total = this.tableData.length
            return this.pagedData
            }
            let result = this.tableData
            .filter((row) => {
                let isIncluded = false
                for (let key of this.propsToSearch) {
                let rowValue = row[key].toString().toLowerCase();
                if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                    isIncluded = true
                }
                }
                return isIncluded
            })
            this.pagination.total = result.length
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
            highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
        },
        data () {
        return {
            productTypes_array: [],
            showBalance: false,
            showBalanceEmail: false,
            showBalanceFtp: false,
            showWorksheet: false,
            showWorksheetEmail: false,
            showWorksheetFtp: false,
            showCharacterAnalysis: false,
            showCharacterAnalysisEmail: false,
            showCharacterAnalysisFtp: false,
            showFM100: false,
            showFM102: false,
            showEmail: false,
            actualAssessment: null,
            logAssessment: [],
            no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/no_data.png',
            isSending: false,
            fullPage: true,
            status_fetch: null,
            analyst_fetch: null,
            office_fetch: null,
            startdate_fetch: null,
            enddate_fetch: null,
            tableData: [],
            regionals_array: [],
            offices_array : [],
            users_array: [],
            skipAssessments: true,
            financialAssessments_array: [],
            addActivityType : false,//Bandera de creación de tipo de actividad
            editActivityType : false,//Bandera de edición de tipo de actividad
            rowEdit: {},
            formName: 'Cargando...',//Nombre del formulario de creación/edición
            model: {
                startdate: '',
                enddate: '',
                user: '',
                regional: '',
                office: '',
                status: '',
            },
            modelValidations: {
            code: {
                required: true,
                numeric: true,
                max: 8
            },
            name: {
                required: true,
                max: 32
            },
            },
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            searchQuery: '',
            propsToSearch: ['code', 'name','analyst'],
            tableColumns: [
            {
                prop: 'code',
                label: 'Cédula',
                minWidth: 120,
                fixed: true
            },
            {
                prop: 'name',
                label: 'Cliente',
                minWidth: 200,
                fixed: true
            },
            {
                prop: 'product',
                label: 'Producto principal',
                minWidth: 200,
                fixed: true
            },
            {
                prop: 'analyst',
                label: 'Analista',
                minWidth: 200,
                fixed: true
            },
            {
                prop: 'status',
                label: 'Estado',
                minWidth: 150,
                fixed: false
            },
            {
                prop: 'date',
                label: 'Fecha',
                minWidth: 250,
                fixed: false
            },
            {
                prop: 'hour',
                label: 'Hora',
                minWidth: 150,
                fixed: false
            },
            {
                prop: 'assessment',
                label: '# solicitud',
                minWidth: 150,
                fixed: false
            },
            // {
            //     prop: 'analyst',
            //     label: 'Analista',
            //     minWidth: 250
            // },
            ],
            logColumns: [
                {
                    prop: 'stage',
                    label: 'Etapa',
                    minWidth: 200
                },
                {
                    prop: 'description',
                    label: 'Descripción',
                    minWidth: 250
                },
                {
                    prop: 'dateTime',
                    label: 'Fecha',
                    minWidth: 250
                },
            ],
        }
        },
        methods: {
            getProductName(productType){
                var product = this.productTypes_array.find(product => product.id == productType)
                return product.name
            },
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setProductTypes(productTypes){
                var vm = this;
                for(let i=0;i<productTypes.edges.length;i++)
                {
                    vm.pushProductTypesData(productTypes.edges[i].node);
                }
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushProductTypesData(node){
                var vm = this;
                vm.productTypes_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name,
                    isActive: node.isActive,
                });
            },
            async openCashFlow(assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'agro/cashflow/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del balance');
                        console.info(error);
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             isCustomerConsolidated(financialAssessment){
                var product = this.productTypes_array.find(product => product.id == financialAssessment.studies[0].productType)
                if(product.name.toLowerCase() == 'consumo') {
                    var secondProduct = this.productTypes_array.find(product => product.id == financialAssessment.studies[1].productType)
                    if(secondProduct.name.toLowerCase() == 'microcrédito' || secondProduct.name.toLowerCase() == 'microcredito') {
                        return false
                    }
                    else {
                        return true
                    }
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             isCustomerPymeConsolidated(financialAssessment){
                var product = this.productTypes_array.find(product => product.id == financialAssessment.studies[0].productType)
                if(product.name.toLowerCase() == 'pequeña empresa') {
                    if(financialAssessment.spouse_study_id != ''){
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             isFirstAgro(financialAssessment,index){
                if(index == 0) {
                    var product = this.productTypes_array.find(product => product.id == financialAssessment.studies[0].productType)
                    if(product.name.toLowerCase() == 'agropecuario') {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            isFirstAgroConsolidated(financialAssessment){
                var product = this.productTypes_array.find(product => product.id == financialAssessment.studies[0].productType)
                if(product.name.toLowerCase() == 'agropecuario') {
                    return true
                }
                else {
                    return false
                }
            },
            isAgroCodebtor(studies){
                var product = this.productTypes_array.find(product => product.id == studies[0].codebtor_product_id)
                if(product.name.toLowerCase() == 'agropecuario') {
                    return true
                }
                else {
                    return false
                }
            },
            isSecondAgro(financialAssessment, index){
                if(index > 0){
                    var product = this.productTypes_array.find(product => product.id == financialAssessment.studies[0].productType)
                    if(product.name.toLowerCase() == 'agropecuario') {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            async openAgroWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'agro/worksheet/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de la hoja de trabajo');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async openAgroMicroWorksheet(assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'agro/comercial/worksheet/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de la hoja de trabajo');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async sendAgroMicroWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareWorksheetByEmailMutationInput = {
                        creditStudy : study,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_AGROMICROWORKSHEET_EMAIL,
                        variables : {
                            input: shareWorksheetByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showNotificationSuccess('La hoja de trabajo ha sido enviada correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            resetPagination() {
                this.pagination = {
                    perPage: 5,
                    currentPage: 1,
                    perPageOptions: [5, 10, 25, 50],
                    total: 0
                }
            },
            verifySession () {
                var vm = this;
                return new Promise(function(resolve, reject) {
                    var accessTokenDecoded = new SecureLS({encodingType: 'aes'});
                    var myToken = accessTokenDecoded.get('adminAccessToken').data;
                    axios.defaults.headers.common["Authorization"] = 'Jwt '+myToken;
                    var refreshToken = accessTokenDecoded.get('adminRefreshToken').data;
                    vm.$apollo.mutate({
                        mutation: VERIFY_TOKEN,
                        variables : {
                            input : {
                                token: myToken,
                            }
                        }
                    }).then((data) => {
                        resolve(true);
                    }).catch((error) => {
                        if(error.graphQLErrors.length > 0)
                        {
                            if (error.graphQLErrors[0].message == "Signature has expired") {
                                vm.$apollo.mutate({
                                    mutation: REFRESH_TOKEN,
                                    variables : {
                                        input : {
                                        refreshToken: refreshToken,
                                        }
                                    }
                                }).then((data) => {
                                    vm.$store.dispatch('updateToken',data.data.refreshToken).then(()=>{
                                        resolve(true);
                                    });
                                }).catch((error) => {
                                    resolve(false);
                                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                                });
                            }
                        }
                        else {
                            resolve(false);
                            vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                        }
                    });
                });
            },
            resetOffice () {
                this.model.office = '';
            },
            async openFM100 (fmId) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'fm100/'+vm.idDecode(fmId),
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        var myWindow = window.open(url)
                        if (myWindow == null) {
                            vm.showFM100 = false;
                            vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del formulario');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async openFM102 (fmId) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'fm102/'+vm.idDecode(fmId),
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        var myWindow = window.open(url)
                        if (myWindow == null) {
                            vm.showFM100 = false;
                            vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del formulario');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async openCharacterAnalysis (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'characteranalysis/'+assessment+'/'+person,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        var myWindow = window.open(url)
                        if (myWindow == null) {
                            vm.showCharacterAnalysis = false;
                            vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de la evaluación de caracter');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async sendCharacterAnalysis (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareAnalysisByEmailMutationInput = {
                        assessment : assessment,
                        person: person,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_ANALYSIS_EMAIL,
                        variables : {
                            input: shareAnalysisByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showCharacterAnalysisEmail = false;
                        vm.showNotificationSuccess('El análisis de caracter ha sido enviado correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showCharacterAnalysisEmail = false;

                        vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async sendFtpCharacterAnalysis (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareAnalysisBySFTPMutationInput = {
                        assessment : assessment,
                        person: person,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_ANALYSIS_FTP,
                        variables : {
                            input: shareAnalysisBySFTPMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showCharacterAnalysisFtp = false;
                        vm.showNotificationSuccess('El análisis de caracter ha sido enviado al SFTP correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showCharacterAnalysisFtp = false;

                        vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async openConsolidatedBalance (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'consolidatedbalance/'+assessment+'/'+person,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        var myWindow = window.open(url)
                        if (myWindow == null) {
                            vm.showBalance = false;
                            vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de un balance consolidado');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async sendConsolidatedBalance (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareGeneralBalanceByEmailMutationInput = {
                        assessment : assessment,
                        person: person,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_GENERAL_BALANCE_EMAIL,
                        variables : {
                            input: shareGeneralBalanceByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showBalanceEmail = false;
                        vm.showNotificationSuccess('El balance ha sido enviado correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showBalanceEmail = false;

                        vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async sendFtpConsolidatedBalance (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareGeneralBalanceBySFTPMutationInput = {
                        assessment : assessment,
                        person: person,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_GENERAL_BALANCE_FTP,
                        variables : {
                            input: shareGeneralBalanceBySFTPMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showBalanceFtp = false;
                        vm.showNotificationSuccess('El balance ha sido enviado al SFTP correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showBalanceFtp = false;

                        vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async openBalance (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'balance/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        var myWindow = window.open(url)
                        if (myWindow == null) {
                            vm.showBalance = false;
                            vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del balance');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async sendBalance (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareBalanceByEmailMutationInput = {
                        creditStudy : study,
                    };
                    vm.errors.clear();
                    vm.$apollo.mutate({
                        mutation: SHARE_BALANCE_EMAIL,
                        variables : {
                            input: shareBalanceByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showBalanceEmail = false;
                        vm.showNotificationSuccess('El balance ha sido enviado al correo de la oficina correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showBalanceEmail = false;

                        vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async sendFtpBalance (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareBalanceBySFTPMutationInput = {
                        creditStudy : study,
                    };
                    vm.errors.clear();
                    vm.$apollo.mutate({
                        mutation: SHARE_BALANCE_FTP,
                        variables : {
                            input: shareBalanceBySFTPMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showBalanceFtp = false;
                        vm.showNotificationSuccess('El balance ha sido enviado al SFTP correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showBalanceFtp = false;

                        vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async openWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'worksheet/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        var myWindow = window.open(url)
                        if (myWindow == null) {
                            vm.showWorksheet = false;
                            vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de la hoja de trabajo');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async sendWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareWorksheetByEmailMutationInput = {
                        creditStudy : study,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_WORKSHEET_EMAIL,
                        variables : {
                            input: shareWorksheetByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showWorksheetEmail = false;
                        vm.showNotificationSuccess('La hoja de trabajo ha sido enviada correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showWorksheetEmail = false;

                        vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async sendFtpWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareWorksheetBySFTPMutationInput = {
                        creditStudy : study,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_WORKSHEET_FTP,
                        variables : {
                            input: shareWorksheetBySFTPMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showWorksheetFtp = false;
                        vm.showNotificationSuccess('La hoja de trabajo ha sido enviada al SFTP correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showWorksheetFtp = false;

                        vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            showBalanceMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showBalance = true;
            },
            showBalanceEmailMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showBalanceEmail = true;
            },
            showBalanceFtpMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showBalanceFtp = true;
            },
            showCharacterAnalysisMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showCharacterAnalysis = true;
            },
            showFM100Method (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showFM100 = true;
            },
            showFM102Method (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showFM102 = true;
            },
            showCharacterAnalysisEmailMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showCharacterAnalysisEmail = true;
            },
            showCharacterAnalysisFtpMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showCharacterAnalysisFtp = true;
            },
            CancelShowCharacterAnalysisMethod () {
                this.actualAssessment = null;
                this.showCharacterAnalysis = false;
            },
            CancelShowFM100Method () {
                this.actualAssessment = null;
                this.showFM100 = false;
            },
            CancelShowFM102Method () {
                this.actualAssessment = null;
                this.showFM102 = false;
            },
            CancelShowCharacterAnalysisEmailMethod () {
                this.actualAssessment = null;
                this.showCharacterAnalysisEmail = false;
            },
            CancelShowCharacterAnalysisFtpMethod () {
                this.actualAssessment = null;
                this.showCharacterAnalysisFtp = false;
            },
            CancelShowBalanceMethod () {
                this.actualAssessment = null;
                this.showBalance = false;
            },
            CancelShowBalanceEmailMethod () {
                this.actualAssessment = null;
                this.showBalanceEmail = false;
            },
            CancelShowBalanceFtpMethod () {
                this.actualAssessment = null;
                this.showBalanceFtp = false;
            },
            CancelShowWorksheetMethod () {
                this.actualAssessment = null;
                this.showWorksheet = false;
            },
            CancelShowWorksheetEmailMethod () {
                this.actualAssessment = null;
                this.showWorksheetEmail = false;
            },
            CancelShowWorksheetFtpMethod () {
                this.actualAssessment = null;
                this.showWorksheetFtp = false;
            },
            showWorksheetMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showWorksheet = true;
            },
            showWorksheetEmailMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showWorksheetEmail = true;
            },
            showWorksheetFtpMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showWorksheetFtp = true;
            },
            showCharacterMethod (index) {
                this.showCharacter = true;
            },
            showEmailMethod (index) {
                this.showEmail = true;
            },
            logDeactivate (index) {
                var vm = this;
                var array = vm.financialAssessments_array.find(i => i.assessment == index.row.assessment, {});
                if (array.changelogSet.edges.length == 0) {
                    return true
                }
                else {
                    return false
                }
            },
            showLog(index) {

                var vm = this;
                var array = vm.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                vm.logAssessment = [];
                let promise = new Promise(function(resolve, reject) {
                    for (let i=0;i<array.changelogSet.edges.length;i++) {
                        vm.logAssessment.push({
                            stage: array.changelogSet.edges[i].node.stage,
                            description: array.changelogSet.edges[i].node.description,
                            dateTime: moment( array.changelogSet.edges[i].node.dateTime).format('LLL a'),
                        })
                    }
                    resolve();
                }).then(function(resolve){
                    VueScrollTo.scrollTo('#toLogTableElement')
                });
            },
            /***
             * Función para setear en la tabla los datos que llegan desde las evalaciones
             */
            setFinancialAssessments(financialAssessments){
                var vm = this;
                vm.financialAssessments_array = [];
                for(let i=0;i<financialAssessments.edges.length;i++)
                {
                    vm.pushFinancialAssessments(financialAssessments.edges[i].node);
                }
                vm.orderFinancialAssessments();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde la Regional
             */
            setRegionals(regionals){
                var vm = this;
                for(let i=0;i<regionals.edges.length;i++)
                {
                    vm.pushRegionalsData(regionals.edges[i].node);
                }
                vm.orderRegionalsData();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde la oficina
             */
            setOffices(offices){
                var vm = this;
                for(let i=0;i<offices.edges.length;i++)
                {
                    vm.pushOfficesData(offices.edges[i].node);
                }
                vm.orderOfficesData();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde el usuario
             */
            setUsers(users){
                var vm = this;
                for(let i=0;i<users.edges.length;i++)
                {
                    vm.pushUsersData(users.edges[i].node);
                }
                vm.orderUsersData();
            },
            /***
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
            if(isLoading == true || isSending == true){
                return true
            }
            else{
                return false
            }
            },

            /***
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /***
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /***
            * Función que cancela la creación/edición de usuarios y resetea los campos
            */
            cancelForm(){
                this.skipAssessments = true;
                this.tableData = [];
                this.logAssessment = [];
                this.model.startdate = '';
                this.model.enddate = '';
                this.model.user = '';
                this.model.status = '';
                this.model.regional = '';
                this.model.office = '';
                this.status_fetch= null;
                this.analyst_fetch= null;
                this.office_fetch= null;
                this.startdate_fetch= null;
                this.enddate_fetch= null;
                this.errors.clear();
            },
            /***
            * Función que cancela la creación/edición de usuarios y resetea los campos
            */
            cancelLogForm(){
                this.logAssessment = [];
                VueScrollTo.scrollTo('#toAssessmentElement')
            },
            /***
            * Función que oculta el formulario de creación/edición una vez realizado un envío de datos al servidor
            */
            reloadData(){
                var vm = this;
                vm.resetForm();
                vm.setVisibleForm(false,false)//Asignamos las variables de visualización del formulario
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushUsersData(node){
                var vm = this;
                vm.users_array.push({
                    id: node.id,
                    name: node.name,
                    surname: node.surname,
                    username: node.username,
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de evaluaciones
            */
            pushFinancialAssessments(node){
                moment.locale('es');
                var vm = this;
                var status;
                var studies = [];
                var codebtors = [];
                var fm100IdCustomer = null;
                var fm100IdCodebtor = null;
                var fm102Id = null;
                var spouse_study_id = null;
                var spouse_id = null;
                var productName = null;
                if (node.status == 'FINISHED') {
                    status = 'Finalizado';
                }
                else {
                    status = 'En trámite';
                }
                if (node.debtor.creditstudySet.edges.length > 0) {
                    for (let i=0;i<node.debtor.creditstudySet.edges.length;i++) {
                        studies.push({
                            id: vm.idDecode(node.debtor.creditstudySet.edges[i].node.id),
                            productType: node.debtor.creditstudySet.edges[i].node.productType.id
                        })
                    }
                }
                productName = vm.getProductName(studies[0].productType);
                if (node.debtor.spouse != null) {
                    spouse_study_id = vm.idDecode(node.debtor.spouse.creditstudy.id);
                    spouse_id = vm.idDecode(node.debtor.spouse.person.id);
                }
                if (node.debtor.fm100 != null) {
                    fm100IdCustomer = node.debtor.fm100.id
                }
                if (node.fm102 != null) {
                    fm102Id = node.fm102.id;
                }
                // if (node.codebtorSet.edges.length > 0) {
                //     for (let i=0;i<node.codebtorSet.edges.length.length;i++) {
                //         var codebtorStudies = [];
                //         if (node.codebtorSet.edges[i].node.creditstudySet.edges.length > 0) {
                //             for (let j=0;j<node.codebtorSet.edges[i].node.creditstudySet.edges.length;j++) {
                //                 codebtorStudies.push({
                //                     id: vm.idDecode(node.codebtorSet.edges[i].node.creditstudySet.edges[j].node.id)
                //                 })
                //             }
                //         }
                //         codebtors.push({
                //             name: node.codebtorSet.edges[i].node.person.fullName,
                //             studies: codebtorStudies
                //         })
                //     }
                // }
                if(node.codebtorSet != null && node.codebtorSet.edges.length != 0) {
                    for (let i=0;i<node.codebtorSet.edges.length;i++) {
                        var codebtorStudies = [];
                        if (node.codebtorSet.edges[i].node.creditstudySet.edges.length > 0) {
                            for (let j=0;j<node.codebtorSet.edges[i].node.creditstudySet.edges.length;j++) {
                                codebtorStudies.push({
                                    codebtor_study: vm.idDecode(node.codebtorSet.edges[i].node.creditstudySet.edges[j].node.id),
                                    codebtor_product_id : node.codebtorSet.edges[i].node.creditstudySet.edges[j].node.productType.id
                                })
                            }
                        }
                        if (node.codebtorSet.edges[i].node.fm100 != null) {
                            codebtors.push({
                                name: node.codebtorSet.edges[i].node.person.fullName,
                                codebtor_id: vm.idDecode(node.codebtorSet.edges[i].node.person.id),
                                fm100IdCodebtor: node.codebtorSet.edges[i].node.fm100.id,
                                studies: codebtorStudies
                            })
                        }
                        else {
                            codebtors.push({
                                name: node.codebtorSet.edges[i].node.person.fullName,
                                codebtor_id: vm.idDecode(node.codebtorSet.edges[i].node.person.id),
                                fm100IdCodebtor: null,
                                studies: codebtorStudies
                            })
                        }

                    }
                }
                vm.financialAssessments_array.push({
                    assessment: vm.idDecode(node.id),
                    status: status,
                    date: moment(node.createdAt).format('LL'),
                    hour: moment(node.createdAt).format('h:mm a'),
                    analyst: node.analyst.user.name + ' ' + node.analyst.user.surname,
                    person: vm.idDecode(node.debtor.person.id),
                    name: node.debtor.person.fullName,
                    code: node.debtor.person.identificationNumber,
                    studies: studies,
                    changelogSet: node.changelogSet,
                    codebtors: codebtors,
                    fm100IdCustomer: fm100IdCustomer,
                    fm102Id: fm102Id,
                    spouse_study_id: spouse_study_id,
                    spouse_id: spouse_id,
                    product: productName
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de regionales
            */
            pushRegionalsData(node){
                var vm = this;
                vm.regionals_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de oficinas
            */
            pushOfficesData(node){
                var vm = this;
                vm.offices_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name,
                    regional: node.regional.id
                });
            },
            /***
            * Función para ordenar el arreglo de datos
            */
            orderData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.tableData, o => o.name);
                // vm.tableData = myOrderedArray;
                vm.tableData = vm.assessments;
            },
            /***
            * Función para ordenar el arreglo de datos de usuarios
            */
            orderUsersData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.users_array, o => o.name);
                vm.users_array = myOrderedArray;
            },
            orderFinancialAssessments(){
                var vm = this;
                // const myOrderedArray = _.sortBy(vm.financialAssessments_array, o => o.assessment);
                const myOrderedArray = _.orderBy(vm.financialAssessments_array, function (obj) {
                    return parseInt(obj.assessment, 10);
                }, ['desc']);
                vm.tableData = myOrderedArray;
            },
            orderRegionalsData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.regionals_array, o => o.name);
                vm.regionals_array = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos de regionales
            */
            orderOfficesData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.offices_array, o => o.name);
                vm.offices_array = myOrderedArray;
            },
            /***
            * Función para decodificar el ID en base 64
            */
            idDecode(id){
                let id_decoded = atob(id);
                return id_decoded.split(":")[1];
            },
            /***
            * Función para mostrar un mensaje de éxito
            */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /***
            * Función para mostrar un mensaje de error
            */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * Función para dar formato de hora a los datos de salida
             */
            momentOutput(date) {
                moment.locale('es');
                return moment(date).format();
            },
            /***
            * Función para validar el formulario de edición y creación que se envía
            */
            validate () {
              this.$validator.validateAll().then(isValid => {
                  if(isValid){
                      var vm = this;
                      vm.tableData = []
                      if((vm.model.startdate != '' && vm.model.enddate == '') || (vm.model.startdate == '' && vm.model.enddate != '')){
                          vm.onError('Las dos fechas son obligatorias');
                          return
                      }
                      if(vm.model.startdate > vm.model.enddate){
                          vm.onError('La fecha de inicio no puede ser mayor a la fecha de fin');
                          return
                      }

                      // Validar que la diferencia entre fechas no supere 7 días
                      if(vm.model.startdate != '' && vm.model.enddate != '') {
                          const startMoment = moment(vm.model.startdate);
                          const endMoment = moment(vm.model.enddate);

                          // Calcular la diferencia en días
                          const diffDays = endMoment.diff(startMoment, 'days');

                          if(diffDays > 7) {
                              vm.onError('La diferencia entre las fechas no puede superar 7 días');
                              return
                          }
                      }

                      if (vm.model.regional == '') {
                          vm.onError('Debe seleccionar una regional');
                          return
                      }
                      if (vm.model.regional != '' && vm.model.office == '') {
                          vm.onError('Debe seleccionar una oficina');
                          return
                      }
                      if (vm.model.regional != '' && vm.model.office != '') {
                          vm.office_fetch = vm.idDecode(vm.model.office);
                      }
                      if (vm.model.startdate != '') {
                          vm.startdate_fetch = vm.momentOutput(vm.model.startdate);
                          vm.enddate_fetch = vm.momentOutput(vm.model.enddate);
                      }
                      if (vm.model.user != '') {
                          vm.analyst_fetch = vm.idDecode(vm.model.user);
                      }
                      if (vm.model.status != '') {
                          vm.status_fetch = vm.model.status;
                      }
                      vm.resetPagination();
                      vm.skipAssessments = false;
                      vm.$apollo.queries.financialAssessments.refetch();
                  }
              })
          }
        },
        beforeMount() {
            moment.locale('es');
            this.model.startdate = moment().startOf('isoWeek').format();
            this.model.enddate = moment().endOf('isoWeek').format();
            this.startdate_fetch = this.momentOutput(moment().startOf('isoWeek').format());
            this.enddate_fetch = this.momentOutput(moment().endOf('isoWeek').format());
        },
        mounted() {
            // this.test();
            // alert(this.$window.csrf_token);
        }
    }
    </script>
    <style lang="scss">
    .el-table .td-actions{
    button.btn {
        margin-right: 5px;
    }
    }
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 500px;
    }
    // Estilos para poder centrar el título de la actividad
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
